export default function ({ app }) {
  app.router.beforeResolve((to, from, next) => {
    // TODO: Create a proper event mechanism
    const event = new CustomEvent('one-route-change', { bubbles: true, detail: { to, from } })
    window.dispatchEvent(event)
    next()
  })
}
